export const BREADCRUMBS_SEPARATORS = {
    chevron: 'chevron',
    slash: 'slash',
    dot: 'dot',
    reverseSlash: 'reverseSlash',
    dash: 'dash',
} as const

export const BREADCRUMBS_SEPARATOR_SYMBOLS = {
    chevron: '',
    slash: '/',
    dot: '·',
    reverseSlash: '\\',
    dash: '-',
} as const
